export default "__VITE_ASSET__CETAx1VM__"